import isObjectLike from './isObjectLike.js';

function isObject(value) {
    return typeof value === 'function' || isObjectLike(value);
}

export { isObject as default };
